export default __webpack_public_path__ + "static/media/app-sidebar-logo.438a48b4.png";